import type { PlainDsdNoteReferenceStatus } from "@/types/plain-dsd-table";
import {
  NOTE_REFERENCE_CELL_FILL,
  NOTE_REFERENCE_CELL_FILL_DIM,
} from "@/utils/dsd-editor/note-reference-colors";

/** 상태별 셀 배경 채움 클래스(기본/흐림). 문구(툴팁·배너)는 화면이 소유한다 — PlainDsdTableView 의 noteReferenceLabelByStatus */
export const NOTE_REFERENCE_STATUS_META: Record<
  PlainDsdNoteReferenceStatus,
  { bgClassName: string; dimBgClassName: string }
> = {
  // 연결 판정(valueLinkVerdictOf)을 셀로 접은 값
  confirmed: {
    bgClassName: NOTE_REFERENCE_CELL_FILL.positive,
    dimBgClassName: NOTE_REFERENCE_CELL_FILL_DIM.positive,
  },
  unconfirmed: {
    bgClassName: NOTE_REFERENCE_CELL_FILL.caution,
    dimBgClassName: NOTE_REFERENCE_CELL_FILL_DIM.caution,
  },
  reference_missing: {
    bgClassName: NOTE_REFERENCE_CELL_FILL.negative,
    dimBgClassName: NOTE_REFERENCE_CELL_FILL_DIM.negative,
  },
  // 연결 없음 — 색을 칠하지 않는다
  unlinked: {
    bgClassName: "",
    dimBgClassName: "",
  },
};
